// Main JS file

// Function to navigate directly to a tab on a course page.
//
function GotoTabByUrlHash() {
    // get the tab id from the url hash
    var hash = window.location.hash;
    // if there is a hash in the url
    if (hash) {
        // get the tab link that has the same id as the hash
        var tabLink = document.querySelector("button[data-target='" + hash + "']");

        // if a tab link was found
        if (tabLink) {
            // click the tab link so that the tab is shown
            tabLink.click();
            // goto to top of page
            window.scrollTo(0, 0);
        }
    }
}


// Tabs
//
function SetupTabs() {
    // Accessibility/aria: http://web-accessibility.carnegiemuseums.org/code/tabs/
    // Inspiration/js: https://codepen.io/kevinpowell/pen/oNQgRKm
    //
    const tabsList = document.querySelector(".tab-selection > ul");
    const tabButtons = tabsList.querySelectorAll("button");
    const tabPanelsContainer = document.querySelector(".tab-content");
    const tabPanels = document.querySelectorAll(".tab-content > div");

    //tabsList.setAttribute("role", "tablist"); // Done in html

    tabsList.querySelectorAll("li").forEach((listitem) => {
        listitem.setAttribute("role", "presentation");
    });

    tabButtons.forEach((tab, index) => {
        //tab.setAttribute("role", "tab"); // Done in html
        if (index === 0) {
            // First tab visible by default
            tab.setAttribute("aria-selected", "true");
        } else {
            tab.setAttribute("tabindex", "-1");
            tabPanels[index].setAttribute("hidden", "true");
        }

        tab.addEventListener("click", (e) => {
            e.preventDefault();
            switchTab(e.currentTarget);
        });

    });

    tabPanels.forEach((panel) => {
        panel.setAttribute("role", "tabpanel");
    });

    tabsList.addEventListener("keydown", (e) => {
        switch (e.key) {
            case "ArrowLeft":
                moveLeft();
                break;
            case "ArrowRight":
                moveRight();
                break;
            case "Home":
                e.preventDefault();
                switchTab(tabButtons[0]);
                break;
            case "End":
                e.preventDefault();
                switchTab(tabButtons[tabButtons.length - 1]);
                break;
        }
    });

    function moveLeft() {
        const currentTab = document.activeElement;
        if (!currentTab.parentElement.previousElementSibling) {
            switchTab(tabButtons[tabButtons.length - 1]);
        } else {
            switchTab(
                currentTab.parentElement.previousElementSibling.querySelector("button")
            );
        }
    }

    function moveRight() {
        const currentTab = document.activeElement;
        if (!currentTab.parentElement.nextElementSibling) {
            switchTab(tabButtons[0]);
        } else {
            switchTab(currentTab.parentElement.nextElementSibling.querySelector("button"));
        }
    }

    function switchTab(newTab) {
        const activePanelId = newTab.getAttribute("data-target");
        const activePanel = tabPanelsContainer.querySelector(activePanelId);

        tabButtons.forEach((button) => {
            button.setAttribute("aria-selected", "false");
            button.setAttribute("tabindex", "-1");
        });

        tabPanels.forEach((panel) => {
            panel.setAttribute("hidden", "true");
        });

        activePanel.removeAttribute("hidden");

        newTab.setAttribute("aria-selected", "true");
        newTab.setAttribute("tabindex", "0");
        newTab.focus();

        // Set the url hash to the id without jumping to the hash
        history.pushState({}, '', activePanelId);
    }
}


var ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => {
    // DOM has loaded

    // Turn off browser auto scroll restoration behavior
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    // Version selector
    //
    var navSelect = document.querySelector('.version_navigation__select');
    if (navSelect) navSelect.onchange = function () {
        document.location.href = navSelect.value;
    };


    if (window.location.pathname !== "/") {
        SetupTabs();
    }

    GotoTabByUrlHash();
});
